/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/no-unused-prop-types */
import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'

import { Button, Input, TextField } from '@mui/material'
import { SearchOutlined } from '@mui/icons-material'
import InputLabel from '@mui/material/InputLabel'
import MenuItem from '@mui/material/MenuItem'
import Select from '@mui/material/Select'
import { cloneDeep } from 'lodash'
import { doesInputMatchCPFFormat } from 'utils/functions'
import {
  APPLICATION_RESULT, APPLICATION_RESULT_FILTERS,
  APPLICATION_STATUS,
  APPLICATION_STATUS_FILTERS,
} from 'utils/constants/kypStatuses'
import { homeParams } from 'utils/constants/searchParams'
import Container, { RightWrapper, LeftWrapper } from './styles'

const SearchBar = (props) => {
  const { setSearchParams } = props
  const [initDate, setInitDate] = useState('')
  const [endDate, setEndDate] = useState('')
  const [searchTerm, setSearchTerm] = useState('')
  const [searchText, setSearchText] = useState('')
  const [status, setStatus] = useState('ALL')
  const [result, setResult] = useState('ALL')

  const handleSearch = () => {
    const searchParams = cloneDeep(homeParams)
    const searchType = doesInputMatchCPFFormat(searchTerm) ? 'applicant_cpf' : 'applicant_name'
    if (searchTerm !== '') searchParams[searchType] = searchTerm.trim()
    searchParams.end_date = endDate === '' ? null : endDate
    searchParams.start_date = initDate === '' ? null : initDate
    searchParams.status = status === 'ALL' ? null : status
    searchParams.result = result === 'ALL' ? null : result
    setSearchParams(searchParams)
  }

  const handleChangeStatus = (event) => {
    const { value } = event.target
    setStatus(value)
  }

  const handleChangeResult = (event) => {
    const { value } = event.target
    setResult(value)
  }

  const handleSubmitSearch = () => {
    setSearchTerm(searchText)
  }

  const handleOnChangeSearchTerm = (event) => {
    setSearchText(event.target.value)
  }

  const handleOnChangeInitDate = (event) => {
    setInitDate(event.target.value)
  }

  const handleOnChangeEndDate = (event) => {
    setEndDate(event.target.value)
  }

  const handleEnter = (event) => {
    if (event.keyCode === 13) {
      event.preventDefault()
      handleSubmitSearch()
    }
    return false
  }

  useEffect(() => {
    handleSearch()
  }, [initDate, endDate, status, searchTerm, result])

  useEffect(() => {
    if (searchText === '') {
      setSearchTerm(searchText)
    }
  }, [searchText])

  return (
    <Container>
      <LeftWrapper>
        <Input
          type="search"
          placeholder="Digite o nome ou CPF do assessor"
          value={searchText}
          onChange={handleOnChangeSearchTerm}
          onKeyUp={handleEnter}
        />
        <Button onClick={handleSubmitSearch}>
          <SearchOutlined />
        </Button>
      </LeftWrapper>
      <RightWrapper>
        <div className="status-filter">
          <InputLabel id="status">Status:</InputLabel>
          <Select
            labelId="status"
            id="status "
            value={status}
            onChange={handleChangeStatus}
            autoWidth
            variant="standard"
          >
            {Object.keys(APPLICATION_STATUS).map((key) => {
              return (
                <MenuItem
                  key={key}
                  style={{
                    fontSize: '1.25rem',
                  }}
                  value={APPLICATION_STATUS[key]}
                >
                  {APPLICATION_STATUS_FILTERS[key]}
                </MenuItem>
              )
            })}
          </Select>
          <div className="status-filter">
            <InputLabel id="result">Resultado:</InputLabel>
            <Select
              labelId="result"
              id="result"
              name="result"
              value={result}
              onChange={handleChangeResult}
              autoWidth
              variant="standard"
            >
              {Object.keys(APPLICATION_RESULT).map((key) => {
                return (
                  <MenuItem
                    key={key}
                    style={{
                      fontSize: '1.25rem',
                    }}
                    value={APPLICATION_RESULT[key]}
                  >
                    {APPLICATION_RESULT_FILTERS[key]}
                  </MenuItem>
                )
              })}
            </Select>
          </div>
        </div>
        <TextField
          variant="standard"
          label="Data início:"
          type="date"
          defaultValue={initDate}
          InputLabelProps={{
            shrink: true,
          }}
          onChange={handleOnChangeInitDate}
        />
        <TextField
          variant="standard"
          label="Data fim:"
          type="date"
          defaultValue={endDate}
          InputLabelProps={{
            shrink: true,
          }}
          onChange={handleOnChangeEndDate}
        />
      </RightWrapper>
    </Container>
  )
}

SearchBar.propTypes = {
  setSearchParams: PropTypes.func.isRequired,
}

export default SearchBar
